"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OP2Event = void 0;
const types_1 = require("../types");
const const_1 = require("./const");
class OP2Event {
    constructor(watchedEvents) {
        this.eventNameClsInstanceMap = watchedEvents.reduce((res, event) => {
            res[event] = new const_1.EventNameClsMap[event]();
            return res;
        }, {});
    }
    getOpsResources(events) {
        const res = new Map();
        events.forEach(event => {
            // datasheet resources
            if (event.scope === types_1.ResourceType.Datasheet) {
                const { datasheetId, recordId } = event.context;
                if (res.has(datasheetId)) {
                    recordId && res.get(datasheetId).push(recordId);
                }
                else {
                    recordId && res.set(datasheetId, [recordId]);
                }
            }
        });
        return res;
    }
    parseOps2Events(changesets) {
        const events = [];
        changesets.forEach(({ operations, resourceId, resourceType }) => {
            operations.forEach(op => {
                events.push(...this.parseOp2Event(op, resourceId, resourceType));
            });
        });
        return events;
    }
    makeVirtualEvents(events, state) {
        // For example: an update of field A causes an update of field B
        const virtualEvents = [];
        Object.keys(this.eventNameClsInstanceMap).forEach((eventName) => {
            const eventClsInstance = this.eventNameClsInstanceMap[eventName];
            const _events = events.filter(event => event.eventName === eventName);
            // The field update event only has the processing logic of the calculation event
            if (eventName === const_1.OPEventNameEnums.CellUpdated) {
                virtualEvents.push(...eventClsInstance.computeEvent(_events, state));
            }
        });
        return virtualEvents;
    }
    makeCombEvents(events) {
        const res = [];
        Object.entries(this.eventNameClsInstanceMap).forEach(eventCls => {
            const [, eventClsInstance] = eventCls;
            if (eventClsInstance.atomType === const_1.EventAtomTypeEnums.COMB) {
                res.push(...eventClsInstance.comb(events));
            }
        });
        return res;
    }
    fillEvents(events, state) {
        return Object.entries(this.eventNameClsInstanceMap).reduce((res, [, eventClsInstance]) => {
            if (eventClsInstance.fill) {
                res = eventClsInstance.fill(res, state);
            }
            return res;
        }, events);
    }
    /**
     * op to real atomic event
     */
    parseOp2Event(op, resourceId, resourceType) {
        const events = [];
        op.actions.forEach(action => {
            const opContext = { op, action, resourceId, resourceType };
            Object.keys(this.eventNameClsInstanceMap).forEach((eventName) => {
                const eventClsInstance = this.eventNameClsInstanceMap[eventName];
                if (eventClsInstance.scope !== resourceType || eventClsInstance.atomType !== const_1.EventAtomTypeEnums.ATOM) {
                    return;
                }
                const { pass, context } = eventClsInstance === null || eventClsInstance === void 0 ? void 0 : eventClsInstance.test(opContext);
                if (pass) {
                    events.push({
                        eventName,
                        realType: const_1.EventRealTypeEnums.REAL,
                        atomType: const_1.EventAtomTypeEnums.ATOM,
                        scope: resourceType,
                        context,
                        sourceType: op.cmd === const_1.REMOTE_NEW_CHANGES ? const_1.EventSourceTypeEnums.REMOTE : const_1.EventSourceTypeEnums.LOCAL,
                    });
                }
            });
        });
        return events;
    }
}
exports.OP2Event = OP2Event;
//# sourceMappingURL=op2event.js.map